module.exports = __webpack_public_path__ + "static/media/onboarding-welcome-round1.8285d8ae.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-welcome-round1.mp4
// module id = 2643
// module chunks = 0